import React, { useState, useEffect } from 'react';
import { useSelector } from 'react-redux';
import { useNavigate } from 'react-router-dom';
import axios from 'axios';
import { FaSearch } from "react-icons/fa";
import { light } from '@mui/material/styles/createPalette';
import { WiTime2 } from "react-icons/wi";

// Confirmation Modal Component
const ConfirmationModal = ({ isOpen, onClose, onConfirm, user, type }) => {
    if (!isOpen || !user) return null;
   console.log("Confirmation Modal User:", user);
    const primaryBlue = "#0044C6";

    return (
        <div
            style={{
                position: "fixed",
                top: 0,
                left: 0,
                right: 0,
                bottom: 0,
                backgroundColor: "rgba(0, 0, 0, 0.5)",
                display: "flex",
                justifyContent: "center",
                alignItems: "center",
                zIndex: 1100, // Higher than main modal
                backdropFilter: "blur(5px)",
            }}
            onClick={onClose}
        >
            <div
                style={{
                    background: "#FFFFFF",
                    borderRadius: "24px",
                    width: "90%",
                    maxWidth: "450px",
                    overflow: "hidden",
                    boxShadow: "0 20px 40px rgba(0,0,0,0.2)",
                    animation: "slideIn 0.3s ease-out",
                }}
                onClick={(e) => e.stopPropagation()}
            >
                {/* Modal Header */}
                <div
                    style={{
                        padding: "1.5rem 2rem",
                        borderBottom: "1px solid #E9EDF4",
                        background: "#F8FAFE",
                    }}
                >
                    <h2
                        style={{
                            fontSize: "1.3rem",
                            fontWeight: 600,
                            color: "#0B1C33",
                            margin: 0,
                            textAlign: "center",
                        }}
                    >
                        Confirm Addition
                    </h2>
                </div>

                {/* User Details */}
                <div style={{ padding: "2rem", textAlign: "center" }}>
                    {/* Profile Picture */}
                    <div
                        style={{
                            width: "80px",
                            height: "80px",
                            borderRadius: "50%",
                            overflow: "hidden",
                            background: "#E9EDF4",
                            border: "3px solid #FFFFFF",
                            boxShadow: "0 4px 12px rgba(0,0,0,0.15)",
                            margin: "0 auto 1.5rem",
                            position: "relative",
                        }}
                    >
                        <img
                            src={user.profile_url || "https://via.placeholder.com/80x80?text=User"}
                            alt={`${user.first_name} ${user.last_name}`}
                            style={{
                                width: "100%",
                                height: "100%",
                                objectFit: "cover",
                            }}
                            onError={(e) => {
                                e.target.src = "https://via.placeholder.com/80x80?text=User";
                            }}
                        />
                        {user.is_verified && (
                            <div
                                style={{
                                    position: "absolute",
                                    bottom: "2px",
                                    right: "2px",
                                    width: "20px",
                                    height: "20px",
                                    background: "#0F9D58",
                                    color: "white",
                                    borderRadius: "50%",
                                    display: "flex",
                                    alignItems: "center",
                                    justifyContent: "center",
                                    border: "2px solid white",
                                    fontSize: "12px",
                                    fontWeight: "bold",
                                }}
                            >
                                ✓
                            </div>
                        )}
                    </div>

                    {/* User Info */}
                    <div style={{ marginBottom: "1.5rem" }}>
                        <div style={{
                            fontWeight: 600,
                            fontSize: "1.2rem",
                            color: "#0B1C33",
                            marginBottom: "0.5rem",
                        }}>
                            {user.first_name} {user.last_name}
                        </div>
                        <div style={{ 
                            fontSize: "0.95rem", 
                            color: "#545558",
                            wordBreak: "break-all"
                        }}>
                            {user?.phone_no || 'Phone not available'}
                        </div>
                        <div style={{ 
                            fontSize: "0.95rem", 
                            color: "#0044C6",
                            marginBottom: "1rem",
                            wordBreak: "break-all"
                        }}>
                            {user.email || 'Email not available'}
                        </div>
                    </div>

                    {/* Confirmation Message */}
                    <div style={{
                        background: "#F5F7FA",
                        padding: "1rem",
                        borderRadius: "12px",
                        marginBottom: "1.5rem",
                    }}>
                        <p style={{
                            color: "#0B1C33",
                            fontSize: "1rem",
                            margin: 0,
                            lineHeight: "1.5",
                        }}>
                            Are you sure you want to add <strong>{user.first_name} {user.last_name}</strong> as a <strong>{type}</strong>?
                        </p>
                    </div>

                    {/* Action Buttons */}
                    <div style={{
                        display: "flex",
                        gap: "1rem",
                        justifyContent: "center",
                    }}>
                        <button
                            onClick={onClose}
                            style={{
                                background: "transparent",
                                color: primaryBlue,
                                border: `1px solid ${primaryBlue}`,
                                borderRadius: "30px",
                                padding: "0.75rem 2rem",
                                fontSize: "0.95rem",
                                fontWeight: 500,
                                cursor: "pointer",
                                transition: "all 0.2s",
                                flex: 1,
                                maxWidth: "120px",
                            }}
                            onMouseEnter={(e) => {
                                e.currentTarget.style.background = "lightgray";
                                e.currentTarget.style.color = "white";
                            }}
                            onMouseLeave={(e) => {
                                e.currentTarget.style.background = "transparent";
                                e.currentTarget.style.color = primaryBlue;
                            }}
                        >
                            No
                        </button>
                        <button
                            onClick={onConfirm}
                            style={{
                                background: primaryBlue,
                                color: "white",
                                border: "none",
                                borderRadius: "30px",
                                padding: "0.75rem 2rem",
                                fontSize: "0.95rem",
                                fontWeight: 500,
                                cursor: "pointer",
                                transition: "all 0.2s",
                                flex: 1,
                                maxWidth: "120px",
                            }}
                            onMouseEnter={(e) => {
                                e.currentTarget.style.background = "#0033a0";
                                e.currentTarget.style.transform = "scale(1.02)";
                            }}
                            onMouseLeave={(e) => {
                                e.currentTarget.style.background = primaryBlue;
                                e.currentTarget.style.transform = "scale(1)";
                            }}
                        >
                            Yes
                        </button>
                    </div>
                </div>
            </div>

            <style>
                {`
          @keyframes slideIn {
            from {
              transform: translateY(-20px);
              opacity: 0;
            }
            to {
              transform: translateY(0);
              opacity: 1;
            }
          }
        `}
            </style>
        </div>
    );
};

// Main AddVolunterModal Component
const AddVolunterModal = ({ isOpen, onClose, type, onAddUser }) => {
    const [searchTerm, setSearchTerm] = useState('');
    const [users, setUsers] = useState([]);
    const [filteredUsers, setFilteredUsers] = useState([]);
    const [loading, setLoading] = useState(false);
    const [loadingMore, setLoadingMore] = useState(false);
    const [addingUserId, setAddingUserId] = useState(null);
    const [offset, setOffset] = useState(1);
    const [hasMore, setHasMore] = useState(true);
    const [initialFetchDone, setInitialFetchDone] = useState(false);
    
    // New state for confirmation modal
    const [showConfirmModal, setShowConfirmModal] = useState(false);
    const [selectedUser, setSelectedUser] = useState(null);

    const objectId = localStorage.getItem("objectId");

    // Fetch users from API
    const fetchUsers = async (query, offsetValue = 1, isLoadMore = false) => {
        try {
            if (isLoadMore) {
                setLoadingMore(true);
            } else {
                setLoading(true);
            }

            const response = await axios.get(
                `${process.env.REACT_APP_BACKEND_URL}/api/v1/usercontact/connection/search-get-user/`,
                {
                    params: {
                        searchParam: query || 'a', // If query is empty, search for 'a' to get initial results
                        limit: 20,
                        offset: offsetValue,
                    },
                    headers: {
                        Authorization: `Bearer ${objectId}`,
                        "Content-Type": "application/json",
                    },
                }
            );

            if (response?.data?.status === "SUCCESS") {
                const newResults = response?.data?.data || [];
                setHasMore(newResults?.length === 20);

                if (isLoadMore) {
                    setUsers((prev) => [...prev, ...newResults]);
                    setFilteredUsers((prev) => [...prev, ...newResults]);
                } else {
                    setUsers(newResults);
                    setFilteredUsers(newResults);
                }
            }
        } catch (error) {
            console.error("Error fetching users:", error);
        } finally {
            setLoading(false);
            setLoadingMore(false);
        }
    };

    // Initial fetch when modal opens
    useEffect(() => {
        if (isOpen && !initialFetchDone) {
            fetchUsers('a', 1, false);
            setInitialFetchDone(true);
        } else if (!isOpen) {
            // Reset states when modal closes
            setSearchTerm('');
            setUsers([]);
            setFilteredUsers([]);
            setOffset(1);
            setHasMore(true);
            setInitialFetchDone(false);
            setAddingUserId(null);
            setSelectedUser(null);
            setShowConfirmModal(false);
        }
    }, [isOpen]);

    // Debounced search
    useEffect(() => {
        const debounceSearch = setTimeout(() => {
            if (isOpen) {
                setOffset(1);
                setHasMore(true);
                if (searchTerm.trim() !== "") {
                    fetchUsers(searchTerm, 1, false);
                } else {
                    // If search is empty, fetch initial results
                    fetchUsers('a', 1, false);
                }
            }
        }, 300);

        return () => clearTimeout(debounceSearch);
    }, [searchTerm, isOpen]);

    // Filter users locally (optional - you can remove this if you want to rely solely on API filtering)
    useEffect(() => {
        if (searchTerm.trim() === '') {
            setFilteredUsers(users);
        } else {
            // You can keep local filtering as a backup or remove it if API already filters
            const filtered = users.filter(user =>
                user.first_name?.toLowerCase().includes(searchTerm.toLowerCase()) ||
                user.last_name?.toLowerCase().includes(searchTerm.toLowerCase()) ||
                `${user.first_name} ${user.last_name}`.toLowerCase().includes(searchTerm.toLowerCase())
            );
            setFilteredUsers(filtered);
        }
    }, [searchTerm, users]);

    const handleScroll = (e) => {
        const { scrollTop, scrollHeight, clientHeight } = e.currentTarget;
        const isNearBottom = scrollHeight - scrollTop <= clientHeight + 50;

        if (isNearBottom && !loadingMore && hasMore && isOpen) {
            const nextOffset = offset + 1;
            setOffset(nextOffset);
            fetchUsers(searchTerm || 'a', nextOffset, true);
        }
    };

    // Updated to show confirmation modal instead of directly adding
    const handleAddClick = (user) => {
        setSelectedUser(user);
        setShowConfirmModal(true);
    };

    // Handle confirmation
    const handleConfirmAdd = async () => {
        if (!selectedUser) return;
        
        setShowConfirmModal(false);
        setAddingUserId(selectedUser.reference_id || selectedUser.id);
        await onAddUser(selectedUser, type);
        setAddingUserId(null);
        setSelectedUser(null);
    };

    // Handle cancel from confirmation modal
    const handleCancelConfirm = () => {
        setShowConfirmModal(false);
        setSelectedUser(null);
    };

    const handleClose = () => {
        onClose();
    };

    const primaryBlue = "#0044C6";

    if (!isOpen) return null;

    return (
        <>
            {/* Main Modal */}
            <div
                style={{
                    position: "fixed",
                    top: 0,
                    left: 0,
                    right: 0,
                    bottom: 0,
                    backgroundColor: "rgba(0, 0, 0, 0.5)",
                    display: "flex",
                    justifyContent: "center",
                    alignItems: "center",
                    zIndex: 1000,
                    backdropFilter: "blur(5px)",
                }}
                onClick={handleClose}
            >
                <div
                    style={{
                        background: "#FFFFFF",
                        borderRadius: "24px",
                        width: "90%",
                        maxWidth: "700px",
                        maxHeight: "80vh",
                        overflow: "hidden",
                        boxShadow: "0 20px 40px rgba(0,0,0,0.2)",
                        animation: "slideIn 0.3s ease-out",
                    }}
                    onClick={(e) => e.stopPropagation()}
                >
                    {/* Modal Header */}
                    <div
                        style={{
                            padding: "1.5rem 2rem",
                            borderBottom: "1px solid #E9EDF4",
                            display: "flex",
                            justifyContent: "space-between",
                            alignItems: "center",
                            background: "#F8FAFE",
                        }}
                    >
                        <h2
                            style={{
                                fontSize: "1.3rem",
                                fontWeight: 600,
                                color: "#0B1C33",
                                margin: 0,
                                textTransform: "capitalize",
                            }}
                        >
                            Add {type}
                        </h2>
                        <button
                            onClick={handleClose}
                            style={{
                                background: "none",
                                border: "none",
                                fontSize: "1.5rem",
                                cursor: "pointer",
                                color: "#6F7D95",
                                padding: "0.5rem",
                                borderRadius: "50%",
                                display: "flex",
                                alignItems: "center",
                                justifyContent: "center",
                                transition: "all 0.2s",
                            }}
                            onMouseEnter={(e) => {
                                e.currentTarget.style.background = "#E9EDF4";
                                e.currentTarget.style.color = "#0B1C33";
                            }}
                            onMouseLeave={(e) => {
                                e.currentTarget.style.background = "none";
                                e.currentTarget.style.color = "#6F7D95";
                            }}
                        >
                            ✕
                        </button>
                    </div>

                    {/* Search Bar */}
                    <div
                        style={{
                            padding: "1.5rem 2rem",
                            borderBottom: "1px solid #E9EDF4",
                        }}
                    >
                        <div
                            style={{
                                display: "flex",
                                alignItems: "center",
                                background: "#F5F7FA",
                                borderRadius: "40px",
                                padding: "0.5rem 1rem",
                                border: "1px solid #E9EDF4",
                                transition: "all 0.2s",
                            }}
                        >
                            <span style={{ color: "#6F7D95", marginRight: "0.5rem" }}><FaSearch /></span>
                            <input
                                type="text"
                                placeholder="Search by name..."
                                value={searchTerm}
                                onChange={(e) => setSearchTerm(e.target.value)}
                                style={{
                                    border: "none",
                                    background: "transparent",
                                    width: "100%",
                                    fontSize: "0.95rem",
                                    padding: "0.5rem 0",
                                    outline: "none",
                                    color: "#0B1C33",
                                }}
                                autoFocus
                            />
                            {searchTerm && (
                                <button
                                    onClick={() => setSearchTerm('')}
                                    style={{
                                        background: "none",
                                        border: "none",
                                        color: "#6F7D95",
                                        cursor: "pointer",
                                        fontSize: "1rem",
                                        padding: "0.25rem 0.5rem",
                                        borderRadius: "50%",
                                    }}
                                >
                                    ✕
                                </button>
                            )}
                        </div>
                    </div>

                    {/* User List with Scroll */}
                    <div
                        style={{
                            padding: "1rem 2rem",
                            overflowY: "auto",
                            maxHeight: "400px",
                        }}
                        onScroll={handleScroll}
                    >
                        {loading ? (
                            <div style={{ textAlign: "center", padding: "3rem" }}>
                                <div style={{ color: primaryBlue, fontSize: "1rem" }}>Loading users...</div>
                            </div>
                        ) : filteredUsers.length > 0 ? (
                            <>
                                {filteredUsers.map((user, index) => (
                                    <div
                                        key={user.reference_id || user.id || index}
                                        style={{
                                            display: "flex",
                                            alignItems: "center",
                                            justifyContent: "space-between",
                                            padding: "1rem",
                                            borderBottom: index < filteredUsers.length - 1 ? "1px solid #EFF2F7" : "none",
                                            transition: "all 0.2s",
                                            borderRadius: "12px",
                                            marginBottom: "0.5rem",
                                        }}
                                        onMouseEnter={(e) => {
                                            e.currentTarget.style.background = "#F8FAFE";
                                        }}
                                        onMouseLeave={(e) => {
                                            e.currentTarget.style.background = "transparent";
                                        }}
                                    >
                                        <div style={{ display: "flex", alignItems: "center", gap: "1rem", flex: 1 }}>
                                            {/* Profile Picture */}
                                            <div
                                                style={{
                                                    width: "56px",
                                                    height: "56px",
                                                    borderRadius: "50%",
                                                    overflow: "hidden",
                                                    background: "#E9EDF4",
                                                    border: "2px solid #FFFFFF",
                                                    boxShadow: "0 2px 8px rgba(0,0,0,0.1)",
                                                    position: "relative",
                                                    flexShrink: 0,
                                                }}
                                            >
                                                <img
                                                    src={user.profile_url || "https://via.placeholder.com/56x56?text=User"}
                                                    alt={`${user.first_name} ${user.last_name}`}
                                                    style={{
                                                        width: "100%",
                                                        height: "100%",
                                                        objectFit: "cover",
                                                    }}
                                                    onError={(e) => {
                                                        e.target.src = "https://via.placeholder.com/56x56?text=User";
                                                    }}
                                                />
                                                {/* Verification Badge */}
                                                {user.is_verified && (
                                                    <div
                                                        style={{
                                                            position: "absolute",
                                                            bottom: "2px",
                                                            right: "2px",
                                                            width: "16px",
                                                            height: "16px",
                                                            background: "#0F9D58",
                                                            color: "white",
                                                            borderRadius: "50%",
                                                            display: "flex",
                                                            alignItems: "center",
                                                            justifyContent: "center",
                                                            border: "2px solid white",
                                                            fontSize: "10px",
                                                            fontWeight: "bold",
                                                            boxShadow: "0 2px 4px rgba(0,0,0,0.2)",
                                                        }}
                                                    >
                                                        ✓
                                                    </div>
                                                )}
                                            </div>

                                            {/* User Info */}
                                            <div style={{ flex: 1 }}>
                                                <div style={{
                                                    fontWeight: 600,
                                                    color: "#0B1C33",
                                                    marginBottom: "0.2rem",
                                                    display: "flex",
                                                    alignItems: "center",
                                                    gap: "0.5rem"
                                                }}>
                                                    {user.first_name} {user.last_name}
                                                </div>
                                                <div style={{ fontSize: "0.85rem", color: "#0044C6", marginBottom: "0.2rem" }}>
                                                    {user.email || 'Email not available'}
                                                </div>
                                            </div>
                                        </div>

                                        {/* Add Button */}
                                        <button
                                            onClick={() => handleAddClick(user)}
                                            disabled={addingUserId === (user.reference_id || user.id)}
                                            style={{
                                                background: addingUserId === (user.reference_id || user.id) ? "#6F7D95" : primaryBlue,
                                                color: "white",
                                                border: "none",
                                                borderRadius: "30px",
                                                padding: "0.6rem 1.5rem",
                                                fontSize: "0.9rem",
                                                fontWeight: 500,
                                                cursor: addingUserId === (user.reference_id || user.id) ? "not-allowed" : "pointer",
                                                display: "flex",
                                                alignItems: "center",
                                                gap: "0.3rem",
                                                transition: "all 0.2s",
                                                opacity: addingUserId === (user.reference_id || user.id) ? 0.7 : 1,
                                                minWidth: "80px",
                                                justifyContent: "center",
                                                marginLeft: "1rem",
                                            }}
                                            onMouseEnter={(e) => {
                                                if (addingUserId !== (user.reference_id || user.id)) {
                                                    e.currentTarget.style.background = "#0033a0";
                                                    e.currentTarget.style.transform = "scale(1.02)";
                                                }
                                            }}
                                            onMouseLeave={(e) => {
                                                if (addingUserId !== (user.reference_id || user.id)) {
                                                    e.currentTarget.style.background = primaryBlue;
                                                    e.currentTarget.style.transform = "scale(1)";
                                                }
                                            }}
                                        >
                                            {addingUserId === (user.reference_id || user.id) ? (
                                                <>
                                                    <WiTime2/> Adding...
                                                </>
                                            ) : (
                                                <>
                                                    <span style={{ fontSize: "1rem" }}>+</span> Add
                                                </>
                                            )}
                                        </button>
                                    </div>
                                ))}

                                {/* Loading More Indicator */}
                                {loadingMore && (
                                    <div style={{ textAlign: "center", padding: "1rem" }}>
                                        <div style={{ color: primaryBlue, fontSize: "0.9rem" }}>Loading more users...</div>
                                    </div>
                                )}

                                {/* No More Results */}
                                {!hasMore && filteredUsers.length > 0 && (
                                    <div style={{ textAlign: "center", padding: "1rem", color: "#6F7D95" }}>
                                        No more users to load
                                    </div>
                                )}
                            </>
                        ) : (
                            <div style={{ display:"flex", justifyContent: "center", alignItems: "center", flexDirection: "column", padding: "3rem" }}>
                                <div style={{ fontSize: "3rem", marginBottom: "1rem", color:"#9AA6B5" }}><FaSearch /></div>
                                <div style={{ color: "#6F7D95", fontSize: "1rem", marginBottom: "0.5rem" }}>
                                    No users found
                                </div>
                                <div style={{ color: "#9AA6B5", fontSize: "0.9rem" }}>
                                    Try searching with different keywords
                                </div>
                            </div>
                        )}
                    </div>

                    {/* Modal Footer */}
                    <div
                        style={{
                            padding: "1.5rem 2rem",
                            borderTop: "1px solid #E9EDF4",
                            display: "flex",
                            justifyContent: "flex-end",
                            background: "#F8FAFE",
                        }}
                    >
                        <button
                            onClick={handleClose}
                            style={{
                                background: "transparent",
                                color: primaryBlue,
                                border: `1px solid ${primaryBlue}`,
                                borderRadius: "30px",
                                padding: "0.6rem 1.5rem",
                                fontSize: "0.95rem",
                                fontWeight: 500,
                                cursor: "pointer",
                                transition: "all 0.2s",
                            }}
                            onMouseEnter={(e) => {
                                e.currentTarget.style.background = primaryBlue;
                                e.currentTarget.style.color = "white";
                            }}
                            onMouseLeave={(e) => {
                                e.currentTarget.style.background = "transparent";
                                e.currentTarget.style.color = primaryBlue;
                            }}
                        >
                            Cancel
                        </button>
                    </div>
                </div>

                {/* Add animation styles */}
                <style>
                    {`
              @keyframes slideIn {
                from {
                  transform: translateY(-20px);
                  opacity: 0;
                }
                to {
                  transform: translateY(0);
                  opacity: 1;
                }
              }
            `}
                </style>
            </div>

            {/* Confirmation Modal */}
            <ConfirmationModal
                isOpen={showConfirmModal}
                onClose={handleCancelConfirm}
                onConfirm={handleConfirmAdd}
                user={selectedUser}
                type={type}
            />
        </>
    );
};

export default AddVolunterModal;